import React from 'react'
import PropTypes from 'prop-types'
import './LandingPage.css'
import ImageTextGroup from '../components/ImageTextGroupComponent'

const LandingPage = (props) => {
	return (
		<div className="LandingPage">
			<ImageTextGroup content={props.content} groupDirection="row" itemDirection="column" startWith="image" contentGroupName="Page1"/>
			<ImageTextGroup content={props.content} groupDirection="column" itemDirection="row" startWith="image" contentGroupName="Page3" special="flip-flop"/>
		</div>
	)
}

LandingPage.propTypes = {
	content: PropTypes.object.isRequired
}

export default LandingPage



// WEBPACK FOOTER //
// ./src/pages/LandingPage.js